import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import HistoryIcon from 'material-ui/svg-icons/action/history';
import LineStyle from 'material-ui/svg-icons/action/line-style';
import CallMerge from 'material-ui/svg-icons/communication/call-merge';
import Airplane from 'material-ui/svg-icons/device/airplanemode-active';
import WatchLater from 'material-ui/svg-icons/action/watch-later';
import Error from 'material-ui/svg-icons/alert/error';
import { TableRowColumn } from 'material-ui/Table';
import { incidentOperations } from '../../../redux/incident';
import {
  fetchIncidentById,
  zoomToGeometry,
  fetchIncidentHistory
} from '../../../esri/mapHub';
import {
  defineIncident,
  getCurrentRouteFragment
} from '../../../utils/helpers';
import PathNavLink from '../../common/PathNavLink';
import IncidentDetailsHeader from './IncidentDetailsHeader';
import IncidentHistory from './IncidentHistory';
import ResourceHistory from './ResourceHistory';
import Resources209 from './Resources209';
import InvalidIdPage from './InvalidIdPage';
import RelationshipDetails from './RelationshipDetails';
import MapContainer from '../../MapContainer';
import IncidentOverview from './IncidentOverview';
import originFields from '../../../defaults/PointOfOriginFields.json';
import gridDefinition from '../../../defaults/datagrids/incidentHistory.json';

const styles = {
  cardContainer: {
    background: '#eceff5'
  },
  chipLabelStyle: {
    fontSize: '12px',
    lineHeight: '26px'
  }
};

class IncidentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
  }

  componentDidMount() {
    if (this.props.map.loaded) {
      this.getIncident(this.props.match.params.id);
    }
  }

  componentDidUpdate() {
    // if (this.props.map.loaded && this.props.currentIncident && ) {
    //   if (!this.props.incidentHistory.incidents.length &&
    //     this.props.currentIncident.attributes.IrwinID !== (this.props.incidentHistory.incidents[0] && this.props.incidentHistory.incidents[0].attributes.IrwinID)) {
    //     this.getIncidentHistory();
    //   }
    // }
  }

  getIncidentHistory = () => {
    const options = {
      baseQuery: this.getBaseQuery(),
      pageSize: null,
      page: null,
      returnGeometry: true
    };

    this.incidentsAreLoading();

    fetchIncidentHistory(options).then(
      results => {
        this.updateIncidentList(
          results.featureSet.features,
          results.count,
          results.featureSet.exceededTransferLimit || false
        );
      },
      error => {
        console.error('Error loading items.', error);
      }
    );
  };

  getBaseQuery() {
    const id = originFields.idFields.incidents;
    const value = this.props.match.params.id;
    const baseClause = gridDefinition.baseQuery
      ? `AND (${gridDefinition.baseQuery})`
      : '';
    return `(${id} = '${value}') ${baseClause}`;
  }

  updateIncidentList = (incidents, incidentCount, isMore, dataGridOptions) => {
    this.props.setHistoryIncidents({
      incidents
    });
    this.props.setHistoryIncidentCount({
      incidentCount
    });
    this.props.setHistoryIsMore({
      isMore
    });
    this.incidentsHaveLoaded();
    this.getStats(incidents, incidentCount);
  };

  getStats = (incidents, count) => {
    const totalUpdates = count;
    const modifiedBySystems = [
      ...new Set(
        incidents.map(incident => incident.attributes.ModifiedBySystem)
      )
    ];
    this.props.setCurrentIncidentStats({ totalUpdates, modifiedBySystems });
  };

  incidentsHaveLoaded = () => {
    this.props.setHistoryLoading({ loading: false });
  };

  incidentsAreLoading = () => {
    this.props.setHistoryLoading({ loading: true });
  };

  // This lifecycle method will not fire on route-changes, but is necessary to
  // handle the case where this component initially renders BEFORE the map,
  // resulting in subsequently updated props (this.props.map.loaded)
  componentWillReceiveProps(nextProps) {
    if (!this.props.map.loaded && nextProps.map.loaded) {
      this.getIncident(nextProps.match.params.id);
      return;
    }

    const matchId = nextProps.match.params.id;
    const currentIncident = nextProps.currentIncident;

    if (
      matchId &&
      currentIncident &&
      matchId.toUpperCase() !==
        currentIncident.attributes[
          originFields.idFields.incidents
        ].toUpperCase()
    ) {
      this.getIncident(nextProps.match.params.id);
    }
  }

  getCurrentRoute(path) {
    let route = getCurrentRouteFragment(path);
    if (['complex', 'merge', 'conflict'].indexOf(route) === -1) {
      route = 'details';
    }
    return route;
  }

  getIncident(id) {
    fetchIncidentById(id, { includeRelationships: true }).then(
      response => {
        if (!response) {
          this.setState({ isValid: false });
          return;
        }

        const incident = defineIncident(response);
        this.props.setCurrentIncident(incident);
        // zoom to the feature
        const geometry = incident.geometry;
        if (geometry) {
          zoomToGeometry(geometry);
        }

        this.getIncidentHistory();
      },
      error => {
        console.error(error);
        this.setState({ isValid: false });
      }
    );
  }

  getConditionalNavLinks = incident => {
    if (
      !incident ||
      (incident.attributes.IsValid === 0 &&
        incident.attributes.IncidentTypeCategory !== 'OR')
    ) {
      return null;
    }

    const links = [];
    const q = window.location.search;

    if (incident.attributes.IncidentTypeCategory === 'CX') {
      links.push(
        <PathNavLink
          to={`/incidents/${this.props.match.params.id}/complex${q}`}
          key="complex"
        >
          <LineStyle />
          <span>Complex Details</span>
        </PathNavLink>
      );
    }

    if (incident.derived.isMergeParent) {
      links.push(
        <PathNavLink
          to={`/incidents/${this.props.match.params.id}/merge${q}`}
          key="merge"
        >
          <CallMerge />
          <span>Merge Details</span>
        </PathNavLink>
      );
    }

    if (incident.derived.isConflictParent) {
      links.push(
        <PathNavLink
          to={`/incidents/${this.props.match.params.id}/conflict${q}`}
          key="conflict"
        >
          <Error />
          <span>Conflict Details</span>
        </PathNavLink>
      );
    }
    if (incident.derived.isResponseParent) {
      links.push(
        <PathNavLink
          to={`/incidents/${this.props.match.params.id}/providingresponse${q}`}
          key="providingresponse"
        >
          <Error />
          <span>Relationship Details</span>
        </PathNavLink>
      );
    }
    if (incident.derived.isPrescribedParent) {
      links.push(
        <PathNavLink
          to={`/incidents/${this.props.match.params.id}/prescribedescape${q}`}
          key="prescribedescape"
        >
          <Error />
          <span>Prescribe Escape Fire Details</span>
        </PathNavLink>
      );
    }
     if (incident.derived.isPostFireParent) {
      links.push(
        <PathNavLink
          to={`/incidents/${this.props.match.params.id}/postfire${q}`}
          key="postfire"
        >
          <Error />
          <span>Post Fire Details</span>
        </PathNavLink>
      );
    }
    return links;
  };

  getPanels() {
    if (!this.props.currentIncident) return null;

    return (
      <Fragment>
        <Switch>
          {/* redirect to support backwards compatibility now that the
          "/history" url path is deprecated and the IncidentHistory component
          replaces the IncidentDetailsSection component's url path */}
          <Redirect from="/incidents/:id/history" to="/incidents/:id" />
          <Route exact path="/incidents/:id" component={IncidentHistory} />
        </Switch>
        <Route path="/incidents/:id/resources" component={Resources209} />
        <Route
          path="/incidents/:id/resource-history"
          component={ResourceHistory}
        />
        <Route path="/incidents/:id/complex" component={RelationshipDetails} />
        <Route path="/incidents/:id/merge" component={RelationshipDetails} />
        <Route path="/incidents/:id/conflict" component={RelationshipDetails} />
        <Route
          path="/incidents/:id/providingresponse"
          component={RelationshipDetails}
        />
         <Route
          path="/incidents/:id/prescribedescape"
          component={RelationshipDetails}
        />
         <Route
          path="/incidents/:id/postfire"
          component={RelationshipDetails}
        />
      </Fragment>
    );
  }

  render() {
    if (!this.state.isValid) {
      return <InvalidIdPage id={this.props.match.params.id} />;
    }

    const currentIncident = this.props.currentIncident;
    const q = window.location.search;

    return (
      <div className="incident-details-wrapper">
        <div className="incident-details-row">
          <div className="details-cards" style={styles.cardContainer}>
            <IncidentDetailsHeader
              incident={currentIncident}
              auth={this.props.auth}
              directorGroup={this.props.appConfig.directorGroup}
            />
            <IncidentOverview item={currentIncident} stats={this.props.stats} />
          </div>
          <MapContainer isDetailMap />
        </div>
        <div className="incident-history-row">
          <div className="incident-details-toggle">
            <PathNavLink
              exact
              to={`/incidents/${this.props.match.params.id}${q}`}
            >
              <HistoryIcon />
              <span>History</span>
            </PathNavLink>
            {this.getConditionalNavLinks(currentIncident)}
            <PathNavLink
              to={`/incidents/${
                this.props.match.params.id
              }/resource-history${q}`}
            >
              <WatchLater />
              <span>Resource History</span>
            </PathNavLink>

            <PathNavLink
              to={`/incidents/${this.props.match.params.id}/resources${q}`}
            >
              <Airplane />
              <span>209 Resources</span>
            </PathNavLink>
          </div>
          {this.getPanels()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  appConfig: state.config,
  currentIncident: state.incident.currentIncident,
  incidentHistory: state.incident.history,
  stats: state.incident.stats,
  auth: state.auth
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...incidentOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IncidentDetails)
);



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/index.js